import { Amplify } from 'aws-amplify';
import { Pool } from './config';

const configureAmplify = (pool: Pool) => {
  const { oauth, ...rest } = pool;

  Amplify.configure({
    Auth: {
      ...rest,
      region: 'eu-west-1',
      mandatorySignIn: true,
      authenticationFlowType: 'USER_PASSWORD_AUTH' as const,
      ...(oauth ? { oauth } : {}),
    },
  });
};

export { configureAmplify };
